﻿/* eslint-disable no-console */
import { Widget } from "blue-widgets";

class ProductDetailsPage extends Widget {
    constructor(el) {
        super(el);
        this.el = el;

        if (!this.el) return;
        this.selectedAttributes = {};
        this.isInitializationComplete = false;
        this.pageKey = this.el.getAttribute("data-page-key");
        this.inputs = this.el.querySelectorAll("input[type=\"radio\"]");
        this.apiUrl = this.el.getAttribute("data-api-url");
        this.addToCardApiUrl = this.el.getAttribute("data-add-to-cart-api-url");
        this.addToCartButton = this.el.querySelector(".js-add-to-cart");
        this.productReference = this.el.getAttribute("data-product-reference");
        this.productVariantReference = this.el.getAttribute("data-product-variant-reference");
        this.culture = this.el.getAttribute("data-culture");
        this.amountInput = this.el.querySelector(".js-product-amount-input");

        this.handleAttributeChange = this.handleAttributeChange.bind(this);

        this.updateProductReferenceAndProductVariatnKey = this.updateProductVariant.bind(this);
        this.updateSpecifications = this.updateSpecifications.bind(this);
        this.updateThumbnailImages = this.updateThumbnailImages.bind(this);
        this.updateProductTableDetails = this.updateProductTableDetails.bind(this);
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.validateQuantity = this.validateQuantity.bind(this);
        this.createAddErrorMessage = this.createAddErrorMessage.bind(this);

        this.init();


    }

    init() {
        const accordions = this.el.querySelectorAll(".accordion");
        accordions.forEach((accordion) => {
            const inputs = accordion.querySelectorAll("input[type='radio']");
            if (inputs.length > 0) {
                inputs[0].checked = true;
                const attributeAlias = inputs[0].name;
                const attributeValue = inputs[0].value;
                this.selectedAttributes[attributeAlias] = attributeValue;
            }
        });

        this.completeInitialization();
    }

    completeInitialization() {
        this.addToCartButton.addEventListener("click", this.handleAddToCart);
        this.addChangeAttributeEventListener();
        this.isInitializationComplete = true;
    }

    async handleAddToCart(event) {
        this.addToCartButton.setAttribute("disabled", "");

        event.preventDefault();

        const quantity = this.amountInput.value;

        this.validateQuantity(quantity);

        await fetch(this.addToCardApiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                productReference: this.productReference,
                productVariantReference: this.productVariantReference,
                culture: this.culture,
                quantity: parseInt(quantity),
                isSample: "false"
            })
        })
            .then((response) => {
                if (response.ok) {
                    return response.json(); // Parse the response as JSON
                } else {
                    throw new Error(`Error: ${response.status}`);
                }
            })
            .then((data) => {
                this.addToCartButton.removeAttribute("disabled", "");
                
                window.dataLayer.push({ ecommerce: null }); // to empty previous ecommerce data
                window.dataLayer.push(JSON.parse(data.addToCartEvent));

                location.reload();
            })
            .catch((error) => {
                this.addToCartButton.removeAttribute("disabled", "");
                alert("Failed to add item to cart");
                console.error("Error sending POST request:", error);
            });
    }

    validateQuantity(quantity) {
        const minQuantity = parseInt(this.amountInput.getAttribute("min"));
        const packSize = parseInt(this.amountInput.getAttribute("step"));
        const errorMessage = "Selected amount exceeds minQuantity and/or invalid packSize"; //this.createAddErrorMessage(minQuantity, packSize);

        if (!isNaN(packSize) || !isNaN(minQuantity)) {

            if (quantity < minQuantity) {
                console.error(errorMessage);
                alert(errorMessage);
                this.addToCartButton.removeAttribute("disabled", "");
            }

            if (packSize && quantity % packSize !== 0) {
                console.error(errorMessage);
                alert(errorMessage);
                this.addToCartButton.removeAttribute("disabled", "");
            }
        }
    }

    createAddErrorMessage(minQuantity, packSize) {
        const addProductErrorMessageTemplate = this.el.getAttribute("data-add-product-error-message-template");

        return addProductErrorMessageTemplate
            .replace("{{Pack Size}}", packSize)
            .replace("{{Minimum Order}}", minQuantity);
    }

    async handleAddToCartSample(event) {
        this.addToCartSampleButton.setAttribute("disabled", "");
        event.preventDefault();

        const addSampleErrorMessage = this.el.getAttribute("data-add-sample-error-message");

        await fetch(this.addToCardApiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                productReference: this.productReference,
                productVariantReference: this.productVariantReference,
                culture: this.culture,
                quantity: this.amountInput.value,
                isSample: "true",
            })
        })
            .then((response) => {
                if (response.ok) {
                    this.addToCartSampleButton.removeAttribute("disabled", "");
                    location.reload();
                } else {
                    this.addToCartSampleButton.removeAttribute("disabled", "");
                    alert(addSampleErrorMessage);
                    console.error("Error sending POST request. Status:", response.status);
                }
            })
            .catch((error) => {
                this.addToCartButton.removeAttribute("disabled", "");
                alert(addSampleErrorMessage);
                console.error("Error sending POST request:", error);
            });
    }

    addChangeAttributeEventListener() {
        const accordions = this.el.querySelectorAll(".accordion");
        accordions.forEach((accordion) => {
            accordion.addEventListener("change", (event) => {
                if (event.target.matches("input[type='radio']")) {
                    const alias = event.target.name;
                    this.handleAttributeChange(event, alias);
                }
            });
        });
    }

    async handleAttributeChange(event, alias) {
        this.selectedAttributes[alias] = event.target.value;
        const attributeValue = event.target.value;
        const postData = {
            productNodeKey: this.pageKey,
            attributes: this.selectedAttributes,
            culture: this.culture
        };
        await this.fetchChanges(postData);
    }

    async fetchChanges(postData) {
        await fetch(this.apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(postData)
        })
            .then(async (response) => {
                if (response.ok) {
                    const json = await response.json();
                    console.log(json);
                    this.updateProductVariant(json.productVariantReference);
                    this.updateSpecifications(json.specifications);
                    this.updateThumbnailImages(json.thumbnailImages);
                    this.updateProductTableDetails(json.productDetailsTable);
                    this.updatePrice(json.originalPrice, json.discountedPrice);
                } else {
                    console.error("Error sending POST request. Status:", response.status);
                    console.error("Error sending POST request. Status:", response);
                }
            })
            .catch((error) => {
                console.error("Error sending POST request:", error);
            });
    }

    updatePrice(originalPrice, discountedPrice) {
        console.log(originalPrice);
        console.log(discountedPrice);
        const originalPriceElement = this.el.querySelector("#js-originalPrice");
        const discountedPriceElement = this.el.querySelector("#js-discountedPrice");
        const standardPriceElement = this.el.querySelector("#js-standardPrice");

        if (originalPriceElement) originalPriceElement.remove();
        if (discountedPriceElement) discountedPriceElement.remove();
        if (standardPriceElement) standardPriceElement.remove();

        const priceContainer = this.el.querySelector(".product-details__header-info > .js-price-target");
        if (discountedPrice) {
            const discountedPricePara = document.createElement("p");
            discountedPricePara.id = "js-discountedPrice";
            discountedPricePara.className = "product-card__price";
            discountedPricePara.innerText = discountedPrice;
            priceContainer.appendChild(discountedPricePara);

            const originalPricePara = document.createElement("p");
            originalPricePara.id = "js-originalPrice";
            originalPricePara.className = "product-card__discount";
            originalPricePara.innerText = originalPrice;
            priceContainer.appendChild(originalPricePara);
        } else {
            const standardPricePara = document.createElement("p");
            standardPricePara.id = "js-standardPrice";
            standardPricePara.className = "product-card__price";
            standardPricePara.innerText = originalPrice;
            priceContainer.appendChild(standardPricePara);
        }
    }

    updateProductVariant(productVariantReference) {
        this.el.setAttribute("data-product-variant-reference", productVariantReference);
    }

    updateThumbnailImages(images) {
        if (!images) return;

        const parentElm = this.el.querySelector(".product-details__carousel");
        const listContainers = this.el.querySelectorAll(".splide__list");

        if (!listContainers) return;

        listContainers.forEach((listContainer) => {
            if (!listContainer) return;

            listContainer.innerHTML = "";

            images.forEach((image) => {
                const listItem = document.createElement("li");
                listItem.classList.add("splide__slide");

                const divElement = document.createElement("div");

                const pictureElement = document.createElement("picture");

                const sourceDesktop = document.createElement("source");
                sourceDesktop.setAttribute("media", "(min-width: 1025px)");
                sourceDesktop.setAttribute("width", "32");
                sourceDesktop.setAttribute("height", "48");
                sourceDesktop.setAttribute("srcset", `${image.desktopSource} 1x, ${image.desktop2xSource} 2x`);

                const sourceTablet = document.createElement("source");
                sourceTablet.setAttribute("media", "(min-width: 743px)");
                sourceTablet.setAttribute("width", "32");
                sourceTablet.setAttribute("height", "48");
                sourceDesktop.setAttribute("srcset", `${image.tabletSource} 1x, ${image.tablet2xSource} 2x`);

                const imgElement = document.createElement("img");
                imgElement.setAttribute("src", `${image.mobileSource}`);
                imgElement.setAttribute("alt", `${image.alternateText}`);
                imgElement.setAttribute("width", "32");
                imgElement.setAttribute("height", "48");

                // Append source elements to the picture element
                pictureElement.appendChild(sourceDesktop);
                pictureElement.appendChild(sourceTablet);

                // Append the img element to the picture element
                pictureElement.appendChild(imgElement);

                // Append the picture element to the div element
                divElement.appendChild(pictureElement);

                // Append the div element to the list item
                listItem.appendChild(divElement);

                // Append the list item to the parent element
                // Replace "parentElement" with the appropriate parent element in your document
                listContainer.appendChild(listItem);
            });
        });
        window.blueWidgetReinit(parentElm);
    }

    updateSpecifications(specifications) {
        if (!specifications) return;
        const productSpecificationsContainer = this.el.querySelector("[data-key=\"product-specificatie\"]");

        if (!productSpecificationsContainer) return;

        productSpecificationsContainer.innerHTML = "";

        specifications.forEach(function (item) {
            // Create the list item element
            const listItem = document.createElement("li");
            listItem.classList.add("product-specificatie-card");

            // Create the input element
            const inputElement = document.createElement("input");
            inputElement.setAttribute("type", "radio");
            inputElement.setAttribute("id", item.label);
            inputElement.setAttribute("name", "product-" + item.value);

            // Create the label element
            const labelElement = document.createElement("label");
            labelElement.setAttribute("for", item.label);
            labelElement.classList.add("subtitle2");
            labelElement.textContent = item.label + ": [" + item.value + "]";

            // Append the input and label elements to the list item
            listItem.appendChild(inputElement);
            listItem.appendChild(labelElement);

            // Append the list item to the parent element
            productSpecificationsContainer.appendChild(listItem);
        });
    }

    updateProductTableDetails(productTableDetails) {
        if (!productTableDetails) return;


        if (!productTableDetails.pricingTableItems) return;

        const tableWrapper = this.el.querySelector(".product-details__table");
        const tableHeaderRow = `
                <tr>
                    <th><p class="subtitle2">${productTableDetails.amountLabel}</p></th>
                    <th>
                        <p class="subtitle2">${productTableDetails.excludingVatLabel}</p>
                        <p class="overline">${productTableDetails.perPackageSizeLabel}</p>
                    </th>
                    <th>
                        <p class="subtitle2">${productTableDetails.includingVatLabel} (21%)</p>
                        <p class="overline">${productTableDetails.perPackageSizeLabel}</p>
                    </th>
                </tr>
        `;

        const unitsTableBody = `
            <div>
                <p class="subtitle1">${productTableDetails.minimumOrderLabel}</p>
                <p class="body2">${productTableDetails.minimumOrder} ${productTableDetails.unitsLabel}</p>
            </div>
            <div>
                <p class="subtitle1">${productTableDetails.soldInPacksLabel}</p>
                <p class="body2">${productTableDetails.packageSize} ${productTableDetails.unitsLabel}</p>
            </div>
        `;

        this.amountInput.setAttribute("min", productTableDetails.minimumOrder);
        this.amountInput.setAttribute("max", productTableDetails.maximumOrder);
        this.amountInput.setAttribute("step", productTableDetails.packageSize);


        const tableBody = tableWrapper.querySelector("tbody");
        const tableHead = tableWrapper.querySelector("thead");
        const unitsTable = tableWrapper.querySelector(".product-details__table-units");
        tableHead.innerHTML = "";
        tableBody.innerHTML = "";
        unitsTable.innerHTML = "";
        tableHead.innerHTML = tableHeaderRow;
        unitsTable.innerHTML = unitsTableBody;

        productTableDetails.pricingTableItems.forEach((item) => {
            // Create the paragraph (<p>) element for the first cell
            const firstCellParagraphElement = document.createElement("p");
            firstCellParagraphElement.classList.add("body2");
            firstCellParagraphElement.textContent = item.title;

            // Create the table row (<tr>) element
            const tableRowElement = document.createElement("tr");

            // Create the first table cell (<td>) element
            const firstTableCell = document.createElement("td");

            // Append the paragraph to the first table cell
            firstTableCell.appendChild(firstCellParagraphElement);

            // Append the first table cell to the table row
            tableRowElement.appendChild(firstTableCell);

            // Create the second table cell (<td>) element
            const secondTableCell = document.createElement("td");

            // Create the paragraph (<p>) element for the second cell
            const secondCellParagraphElement = document.createElement("p");
            secondCellParagraphElement.classList.add("body2");
            secondCellParagraphElement.textContent = item.priceWithoutTax;

            // Append the paragraph to the second table cell
            secondTableCell.appendChild(secondCellParagraphElement);

            // Append the second table cell to the table row
            tableRowElement.appendChild(secondTableCell);

            // Create the third table cell (<td>) element
            const thirdTableCell = document.createElement("td");

            // Create the paragraph (<p>) element for the third cell
            const thirdCellParagraphElement = document.createElement("p");
            thirdCellParagraphElement.classList.add("body2");
            thirdCellParagraphElement.textContent = item.priceWithTax;

            // Append the paragraph to the third table cell
            thirdTableCell.appendChild(thirdCellParagraphElement);

            // Append the third table cell to the table row
            tableRowElement.appendChild(thirdTableCell);

            // Append the table row to the parent table (assuming you have a table element with ID "myTable")
            tableBody.appendChild(tableRowElement);
        });
    }


}

export default ProductDetailsPage;